import { render, staticRenderFns } from "./EditLottosetModal.vue?vue&type=template&id=2b9b98ab&scoped=true&"
import script from "./EditLottosetModal.vue?vue&type=script&lang=js&"
export * from "./EditLottosetModal.vue?vue&type=script&lang=js&"
import style0 from "./EditLottosetModal.vue?vue&type=style&index=0&id=2b9b98ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9b98ab",
  null
  
)

export default component.exports